import { cloneElement, useId } from "react";
import type { ReactElement } from "react";

export const SELECT =
  "h-9 w-full rounded-lg border border-line-strong bg-surface px-2.5 text-sm text-ink focus:border-accent focus:outline-none";

/** A date as the API and `<input type="date">` take it, such as "2027-10-31". */
export function isoDay(date: Date): string {
  return date.toISOString().slice(0, 10);
}

/** The same day a year on, in UTC. */
export function aYearOn(date: Date): string {
  return isoDay(
    new Date(Date.UTC(date.getUTCFullYear() + 1, date.getUTCMonth(), date.getUTCDate())),
  );
}

/** A label above its one control, tied to it by id (a <label> around a <select> would
 * read its options into the name). */
export function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: ReactElement<{ id?: string }>;
}) {
  const id = useId();
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="block text-sm font-medium text-ink">
        {label}
      </label>
      {cloneElement(children, { id })}
      {hint ? <p className="text-xs text-muted">{hint}</p> : null}
    </div>
  );
}
